<!-- display-mobile-02 preview — Google video partners in-feed ad -->
<app-mobile-frame>
  <!-- START: Publisher feed -->
  <div class="gvf-page">
    <!-- The post above the ad, stubbed out: the ad is the subject. -->
    <div class="gvf-card">
      <div class="gvf-head d-flex flex-row">
        <span class="gvf-avatar placeholder"></span>
        <div class="gvf-head-text d-flex flex-column">
          <span class="gvf-bar gvf-bar-lead placeholder"></span>
          <span class="gvf-bar gvf-bar-sub placeholder"></span>
        </div>
      </div>
      <div class="gvf-body d-flex flex-column">
        <span class="gvf-line placeholder"></span>
        <span class="gvf-line placeholder"></span>
      </div>
    </div>

    <span class="gvf-separator"></span>

    <!-- START: Real ad -->
    <div class="gvf-ad">
      <a
        [href]="data.url"
        target="_blank"
        rel="noopener noreferrer"
        class="gvf-player"
      >
        <img *ngIf="thumbnailUrl; else noCreative" class="gvf-creative" [src]="thumbnailUrl" alt="" />

        <ng-template #noCreative>
          <div class="gvf-creative creative-missing">
            <ng-container *ngIf="isResolving; else askForVideo">
              Reading video formats&hellip;
            </ng-container>
            <ng-template #askForVideo>
              Add a {{ format }} video to see this preview
            </ng-template>
          </div>
        </ng-template>

        <!-- The feed plays muted, so the mute mark is the only player chrome.
             Only drawn over a creative — it is white on the grey empty slot. -->
        <i *ngIf="thumbnailUrl" class="bi bi-volume-mute-fill gvf-mute"></i>
      </a>

      <div class="gvf-text">
        <div class="gvf-headline-row d-flex flex-row align-items-center">
          <img
            class="gvf-logo"
            src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
            alt=""
          />
          <div class="gvf-headline">{{ headline }}</div>
        </div>

        <div class="gvf-detail d-flex flex-row align-items-center">
          <div class="gvf-description">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>
          <a
            [href]="data.url"
            target="_blank"
            rel="noopener noreferrer"
            class="gvf-cta"
            >{{ data.ctaText || "Your call to action" }}</a
          >
        </div>
      </div>
    </div>
    <!-- END: Real ad -->

    <span class="gvf-separator"></span>

    <!-- The post under the ad, whose media blocks clip at the frame. -->
    <div class="gvf-card">
      <div class="gvf-head d-flex flex-row">
        <span class="gvf-avatar placeholder"></span>
        <div class="gvf-head-text d-flex flex-column">
          <span class="gvf-bar gvf-bar-lead placeholder"></span>
          <span class="gvf-bar gvf-bar-sub placeholder"></span>
        </div>
      </div>
      <div class="gvf-body d-flex flex-column">
        <span class="gvf-line gvf-line-media placeholder"></span>
        <span class="gvf-line gvf-line-media placeholder"></span>
      </div>
    </div>
  </div>
  <!-- END: Publisher feed -->
</app-mobile-frame>
